module.exports = __webpack_public_path__ + "static/media/upperContentImg.e61fb96b.svg";